import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

const UPLOAD_FROM_URL = gql`
  mutation UploadFromUrl($url: String!, $filetype: String!, $filename: String!) {
    UploadFromUrl(url: $url, filetype: $filetype, filename: $filename) {
      bucket
      key
      url
    }
  }
`;

export interface UploadFromUrlResult {
  bucket: string;
  key: string;
  url: string;
}

export const useUploadFromUrl = (): ((
  url: string,
  filetype: string,
  filename: string
) => Promise<UploadFromUrlResult | undefined>) => {

  const [mutate] = useMutation<
    { UploadFromUrl: UploadFromUrlResult },
    { url: string; filetype: string; filename: string }
  >(UPLOAD_FROM_URL);

  return useCallback(
    async (url: string, filetype: string, filename: string) => {
      const { data } = await mutate({
        variables: { url, filetype, filename }
      });

      if (!data?.UploadFromUrl) {
        return undefined;
    }

      const { bucket, key, url: rawUrl } = data.UploadFromUrl;

      // clean
      const cleanUrl = rawUrl.split('?')[0];

      return { bucket, key, url: cleanUrl };
    },
    [mutate]
  );
};
